export default function validateHourInterval(
  timeToCheck: string,
  { minTime, maxTime }: { minTime?: string; maxTime?: string }
): boolean {
  // Converte para minutos desde meia-noite
  const toMinutes = (time?: string): number => {
    if (!time) return 0
    const [hours, minutes] = time.split(':').map(Number)
    return hours * 60 + minutes
  }

  const check = toMinutes(timeToCheck)
  const min = toMinutes(minTime)
  const max = toMinutes(maxTime)

  if (!min && !max) return true
  if (!min) return check < max
  if (!max) return check > min
  return check > min && check < max
}
